// 国家PK活动-国家之星 2024-08-28 活动
import React from 'react'
import Swiper from 'swiper'
import { inject, observer } from 'src/core/store'
import lang from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'
import brower from 'src/helper/brower'
import './index.less'
import 'swiper/swiper-bundle.min.css'
import { setDocumentTitle, setUidToken, isRtl } from '../../../helper/tool'
import http from 'src/helper/http'
import Countdown from './countdown'
import Sider from './sider'
import LastWeek from './last-week'
import Gift from './gift'
import FixedCard from './fixed-card'
import TabNav from './tab-nav'
import TabNational from './tab-national'
import TabRanking from './tab-ranking'
import TabTask from './tab-task'
import RulesRewards from './rules-rewards'
import MediaModal from './media-modal'
import NoGift from './no-gift'
import { jumpToUser } from 'src/helper/webviewFun'

@inject('store')
@observer
export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
    this.nationalStore = this.props.store.register('activity/national-star')
    this.swiperRef = React.createRef()
  }

  state = {
    playstat: 1,
    playtab: 1,
    lang: lang.en,
    language: 'en',
    langTitleImgs: {
      en: '/img/activity/national-star/img_kv_title_en@2x.png',
      ar: '/img/activity/national-star/img_kv_title_ar@2x.png',
      tr: '/img/activity/national-star/img_kv_title_tr@2x.png',
      ru: '/img/activity/national-star/img_kv_title_ru@2x.webp'
    },
    playMusicStatus: true, // 音乐播放状态
    firstPlay: true, // 是否第一次播放
    audioPlayer: {},
    certificateModalVisible: false,
    rulesRewardsVisible: false,
    tabNavIndex: 0,
    activeTab: 'rules',
    mediaVisible: false,
    activeMedia: {},
    isShowNoGift: false,
    readPoint: 0
  }

  async componentDidMount() {
    let { language } = this.props.location.query
    const that = this
    language = await getlangV2(language, lang)
    this.setState({
      lang: setlang(language, lang),
      tabNavIndex: isRtl(language) ? 2 : 0,
      language
    }, () => {
      setDocumentTitle(this.state.lang.global_star)
    })

    let uid = await setUidToken(this.props.location.query)
    await this.Init(uid)

    if (this.nationalStore.data.gifts.length === 0) {
      this.setState({
        isShowNoGift: true
      })
    } else {
      const audioPlayer = document.getElementById('audioPlayer')
      const audioPlayerPromise = audioPlayer.play()
      this.setState({
        audioPlayer
      })
      if (audioPlayerPromise !== undefined) {
        audioPlayerPromise.then(() => {
          this.setState({
            firstPlay: false
          })
          console.log('音乐自动播放啦')
        }).catch(error => {
          window.addEventListener('click', that.onceTouchStartMusic)
          console.log('音乐没有自动播放', error)
        })
      }
    }

    this.swiperInstance = new Swiper(this.swiperRef.current, {
      autoplay: false,
      slidesPerView: 1,
      initialSlide: isRtl(language) ? 2 : 0,
      autoHeight: true
    })
    this.swiperInstance.on('slideChange', (slide) => {
      const { activeIndex } = slide
      let index = activeIndex
      this.setState({ tabNavIndex: index })
    })
    // this.Init()
  }

  componentWillMount() {
    const that = this
    window.removeEventListener('click', that.onceTouchStartMusic)
  }

  titleImg = () => {
    const { language, langTitleImgs } = this.state
    const imgUrl = langTitleImgs[language] || langTitleImgs.en
    return (<img src={imgUrl} />)
  }

  // 执行一次音乐
  onceTouchStartMusic = () => {
    console.log('开始播放音乐')
    const that = this
    this.play(true)
    this.setState({
      firstPlay: false
    })
    window.removeEventListener('click', that.onceTouchStartMusic)
  }

  onToggleMusic = () => {
    if (this.state.firstPlay) {
      this.play(true)
    } else {
      this.play(!this.state.playMusicStatus)
    }
  }

  // 跳转个人主页
  onJumpToUser = (uid) => {
    this.play(false)
    jumpToUser(uid)
  }

  play = async (isPlay) => {
    const { audioPlayer } = this.state
    if (isPlay) {
      this.setState({ playtab: 1, playMusicStatus: isPlay })
      audioPlayer.play()
    } else {
      this.setState({ playtab: 0, playMusicStatus: isPlay })
      audioPlayer.pause()
    }
  }

  autoplay = async () => {
    if (this.state.playMusicStatus) {
      this.audioValue.play()
      this.setState({
        playstat: 2,
        playtab: 1
      })
    }
  }

  onToggleRulesModal = async (type) => {
    this.setState({
      rulesRewardsVisible: !this.state.rulesRewardsVisible
    })
    if (type) {
      this.setRulesModalTab(type)
    }
  }

  setRulesModalTab = (type) => {
    this.setState({
      activeTab: type
    })
  }

  goToSlide = (index) => {
    if (this.swiperInstance) {
      this.swiperInstance.slideTo(index)
      this.setState({ tabNavIndex: index })
    }
  }

  // 设置播放对象
  onSetActiveMedia = (media) => {
    // 关闭音乐
    this.play(false)
    this.setState({
      activeMedia: {
        show_url: media.show_url,
        show_key: media.show_key,
        show_type: media.show_type,
        vap_json: media.vap_json
      },
      mediaVisible: true
    })
  }

  // 关闭 MediaModal
  onCloseMediaModal = () => {
    this.setState({
      mediaVisible: false,
      activeMedia: {}
    })
  }

  getRedpoint = async () => {
    const data = await http.post('/web/activity/redpoint', {
      activityKey: 'nationalStar'
    })
    const { code, res } = data

    if (code === 0 && res) {
      this.setState({
        readPoint: res.redNum
      })
    }
  }

  // 初始化
  Init = async (uid) => {
    this.setState({ uid: uid })
    await Promise.all([
      this.nationalStore.getMyAccountInfo(),
      this.nationalStore.getActivityTimeinfo(),
      this.nationalStore.getGiftInfo(),
      this.nationalStore.getRankTop3(),
      this.nationalStore.getRanking('country'),
      this.nationalStore.getRanking('nationalUser')
    ])
    this.getRedpoint()
  }

  render() {
    const {
      userInfo,
      activityTime,
      countryList,
      rankingList,
      rankTop3,
      gifts,
      countryMine,
      rankingMine,
      rewardInfo,
      activeGiftId,
      rewardlist
    } = this.nationalStore.data
    const {
      lang,
      language,
      tabNavIndex,
      rulesRewardsVisible,
      activeTab,
      mediaVisible,
      activeMedia,
      isShowNoGift,
      readPoint
    } = this.state
    return (
      <div className='main'>
        {
          isShowNoGift && (
            <NoGift language={language} txt={lang.no_gift} />
          )
        }
        {
          !isShowNoGift && (
            <div className='page-contant'>
              <div className="banner-wrap">
                <div className="banner-tit">
                  {this.titleImg()}
                </div>
                <Sider
                  playMusicStatus={this.state.playMusicStatus}
                  onToggleMusic={this.onToggleMusic}
                  onToggleModal={this.onToggleRulesModal}
                />
                <Countdown
                  remaintime={activityTime.remaintime}
                  beginTime={activityTime.beginTime}
                  endTime={activityTime.endTime}
                  language={language}
                  lang={lang}
                />
              </div>
              {
                rankTop3.length > 0 && (
                  <LastWeek list={rankTop3} lang={lang} />
                )
              }
              <Gift list={gifts} lang={lang} language={language} />
              <TabNav
                active={tabNavIndex}
                lang={lang}
                language={language}
                isRedPoint={readPoint}
                onSlideTo={this.goToSlide}
              />
              <div className="tab-contant">
                <div className="swiper-container" ref={this.swiperRef}>
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      {
                        isRtl(language) ? (
                          <TabTask
                            lang={lang}
                            giftList={gifts}
                            rewardInfo={rewardInfo}
                            activeGiftId={activeGiftId}
                            language={language}
                            userInfo={userInfo}
                            onSetActiveMedia={this.onSetActiveMedia}
                            getRedpoint={this.getRedpoint}
                          />
                        ) : (
                          <TabNational
                            tabType="national"
                            lang={lang}
                            countryList={countryList}
                            language={language}
                          />
                        )
                      }
                    </div>
                    <div className="swiper-slide">
                      <TabRanking
                        tabType="ranking"
                        lang={lang}
                        rankingList={rankingList}
                        language={language}
                        onJumpToUser={this.onJumpToUser}
                      />
                    </div>
                    <div className="swiper-slide">
                      {
                        isRtl(language) ? (
                          <TabNational
                            tabType="national"
                            lang={lang}
                            countryList={countryList}
                            language={language}
                          />
                        ) : (
                          <TabTask
                            lang={lang}
                            giftList={gifts}
                            rewardInfo={rewardInfo}
                            activeGiftId={activeGiftId}
                            language={language}
                            userInfo={userInfo}
                            onSetActiveMedia={this.onSetActiveMedia}
                            getRedpoint={this.getRedpoint}
                          />
                        )
                      }
                    </div>
                  </div>
                </div>
                {/* <div className="tab-sider">
                  <div
                    className="tab-sider-item"
                    onClick={() => this.onToggleRulesModal('rules')}
                  >
                    <div className="tab-sider-icon">
                      <img src="/img/activity/national-star/icon_rules@2x.png" alt="rule" />
                    </div>
                    <p>{lang.rules}</p>
                  </div>
                  <div
                    className="tab-sider-item"
                    onClick={() => this.onToggleRulesModal('rewards')}
                  >
                    <div className="tab-sider-icon">
                      <img src="/img/activity/national-star/icon_rewards@2x.png" alt="gift" />
                    </div>
                    <p>{lang.rewards}</p>
                  </div>
                </div> */}
              </div>
              {
                ((isRtl(language) && tabNavIndex > 0) || (language !== 'ar' && tabNavIndex < 2)) &&
                countryMine &&
                rankingMine &&
                (
                  <FixedCard
                    lang={lang}
                    language={language}
                    index={tabNavIndex}
                    countryMine={countryMine}
                    rankingMine={rankingMine}
                  />
                )
              }
              <RulesRewards
                lang={lang}
                language={language}
                visible={rulesRewardsVisible}
                activeTab={activeTab}
                rewardlist={rewardlist}
                onToggleModal={this.onToggleRulesModal}
                setTab={this.setRulesModalTab}
                onSetActiveMedia={this.onSetActiveMedia}
              />
            </div>
          )
        }
        <MediaModal
          visible={mediaVisible}
          media={activeMedia}
          onClose={this.onCloseMediaModal}
        />
        {
          !isShowNoGift && (
            <audio
              id="audioPlayer"
              autoPlay
              loop
              src={userInfo.countrySong}>
            </audio>
          )
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/index.js